import { useI18n } from "@/shared/composables/use-i18n";
import { setup } from "vue-class-component";
import { Prop, Vue } from "vue-property-decorator";
import {
    VehicleOptionIconIds,
    OptionDto,
    APIResponse,
} from "@/shared/api-contract/api-contract";
import { pageLoaderModel } from "@/shared/models/page-loader";
import { appAxios } from "@/core/utils/appAxios";
import { routerModel } from "@/router/router.model";
import { watch } from "vue";
import { sessionModel } from "@/shared/state/session.model";
import { isEmpty } from "lodash";
import { appLanguageSwitcherModel } from "../app-language-switcher/app-language-switcher.model";

export class AppVehicleOptionsComponent extends Vue {
    @Prop({ required: true })
    vehicleId!: number;
    options: OptionDto[] = [];
    i18n = setup(useI18n);

    @Prop({ default: () => {} })
    getOptions!: (options: OptionDto[]) => void;

    @Prop({ default: true })
    showLabel!: boolean;

    @Prop({ default: false })
    hasIcon!: boolean;

    @Prop({ default: false })
    disableWowEffect!: boolean;

    @Prop({ default: 24 })
    size!: number;

    @Prop()
    onOptionsLoaded?: (vehicleId: number) => void;

    optionIcons = VehicleOptionIconIds;
    pageLoader = pageLoaderModel;

    /** beforeMount() {
        this.pageLoader.toggle(true);
    } **/

    isNotEmpty() {
        return !isEmpty(this.options);
    }

    mounted() {
        watch(
            () => ({
                vehicleId: this.vehicleId,
                lang: appLanguageSwitcherModel.lang.value,
            }),
            async () => {
                if (this.vehicleId > 0) {
                    await this.fetchOptionDtos(this.vehicleId);
                }
            },
            { immediate: true },
        );
    }
    async fetchOptionDtos(vehicleId: number) {
        const isAuthenticated = sessionModel.sessionDto.value?.token;
        const suffix = isAuthenticated ? "vehicles" : "public/vehicles";

        await appAxios.value
            .get<APIResponse<OptionDto[]>>(
                `/client/web/${suffix}/${this.vehicleId}/options?limit=${this.size}${
                    !this.showLabel || this.hasIcon ? "&has_icon=true" : ""
                }`,
            )
            .then((response) => {
                if (response.data.status.code === 200) {
                    if (response.data.status.code !== 200 && !isAuthenticated) {
                        routerModel.router.push("/login");
                    }
                    this.options = response.data.data;
                    if (this.getOptions) {
                        this.getOptions(response.data.data);
                    }
                }
            })
            .catch(console.log)
            .finally(() => {
                if (this.onOptionsLoaded) {
                    this.onOptionsLoaded(vehicleId);
                }
            });
    }
}
